<template>

    <div class="search-bar-container">
        <form @submit.prevent='submit'>
            <input type="text" v-model="title" class="search-bar" :placeholder="placeholder" :title="title"
                   @input="inputVisibility = input.length>0" @keyup="inputChanged()" @blur="inputBlurred()"
                   @focus="inputFocused()"
            />
            <font-awesome-icon icon="search" class="icon" @click="submit"/>
        </form>
    </div>

</template>

<script>
    import Vue from 'vue'
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faSearch} from '@fortawesome/free-solid-svg-icons'
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

    library.add(faSearch);
    Vue.component('font-awesome-icon', FontAwesomeIcon)

    export default {

        name: "search-bar",

        props: {
            placeholder: {
                type: String,
                default: 'Rechercher'
            },
            title: {
                type: String,
                default: ''
            },
            inSubmit: {
                type: Function
            },
            input: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                inputVisibility: true,
            }
        },
        methods: {
            submit() {
                this.inSubmit(this.title);
            },
            inputChanged() {
                this.$emit('changed', this.title)
            },
            inputBlurred() {
                this.$emit('blurred', this.title)
            },
            inputFocused() {
                this.$emit('focused', this.title)
            },
        },
        directives: {
            elasticInput: {
                bind(el) {
                    el.addEventListener('click', () => {
                        el.previousSibling.style.width = "var(--search-bar-input-width)";
                });
                }
            }
        }
    }

</script>

<style scoped>
    .search-bar-container {
        width: var(--search-bar-input-width, 30vh);
        height: var(--search-bar-input-height, inherit);
        outline: var(--search-bar-input-outline, none);
        padding: var(--search-bar-input-padding, 10px);
        border-top: var(--search-bar-input-border-top, 1px solid #dee0e6);
        border-right: var(--search-bar-input-border-right, 1px solid #dee0e6);
        border-bottom: var(--search-bar-input-border-bottom, 1px solid #dee0e6);
        border-left: var(--search-bar-input-border-left, 1px solid #dee0e6);
        border-radius: var(--search-bar-input-radius, 12px 0px 0px 12px);
        background: var(--search-bar-input-bg, #fff);
        opacity: var(--search-bar-input-opacity, 1);
    }

    .search-bar {
        background: transparent;
        border: none;
        width: var(--search-bar-input-text-width, 90%);
        outline: none;
        color: var(--search-bar-input-text-color, #fff);
        padding: var(--search-bar-input-text-padding, 0px 0px 0px 16px);
        font-size: var(--search-bar-input-text-size, 1.5rem);
        transition: all 0.4s ease;
    }

    .icon {
        width: var(--search-bar-icon-width, 3%);
        height: var(--search-bar-icon-height, 3%);
        color: var(--search-bar-icon-color, #d3d3d3);
        float: var(--search-bar-btn-float);
        cursor: pointer;
    }

    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: var(--search-bar-input-placeholder-color, #fff);
        opacity: var(--search-bar-input-placeholder-opacity, 1);
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: var(--search-bar-input-placeholder-color, #fff);
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: var(--search-bar-input-placeholder-color, #fff);
    }
</style>



// WEBPACK FOOTER //
// node_modules/search-bar/src/components/Component.vue